import {
  LocationStatusFacetFormDefaultValues,
  LocationStatusFacetFormProps,
  LocationStatusFacetFormRawValues,
  LocationStatusFacetFormType,
  LocationStatusFacetFormValues
} from "./LocationStatusFacetForm";
import {useTranslation} from "react-i18next";
import {useForm} from "@mantine/form";
import {adjustFromTimeZoneSafely, getObjectId, LocationStatusFacetEntity} from "@ots-frontend/ots-data";

export const toFormDefaultsFromLocationStatusFacet = (loc: LocationStatusFacetEntity | undefined): Partial<LocationStatusFacetFormValues> => {
  return {
    site: loc?.siteId,
    serviceType: loc?.serviceTypeId,
    statusFacet: loc?.statusFacet,
    status: loc?.status,
    asOfDate: adjustFromTimeZoneSafely(loc?.asOfDttm),
    serviceMode: loc?.serviceMode,
    confidencePct: loc?.confidencePct,
    note: loc?.note,
  };
};

const getInitialValues = (defaultValues: LocationStatusFacetFormDefaultValues | undefined): LocationStatusFacetFormRawValues => {
  return {
    site: getObjectId(defaultValues?.site),
    serviceType: getObjectId(defaultValues.serviceType),
    statusFacet: defaultValues?.statusFacet,
    status: defaultValues?.status,
    asOfDate: defaultValues?.asOfDate,
    serviceMode: defaultValues?.serviceMode,
    confidencePct: defaultValues?.confidencePct,
    note: defaultValues?.note,
  }
}

export type UseLocationStatusFacetFormProps = Pick<LocationStatusFacetFormProps, 'defaultValues'> & {}

export function useLocationStatusFacetForm(props: UseLocationStatusFacetFormProps): LocationStatusFacetFormType {
  const {
    defaultValues
  } = props

  const {t} = useTranslation(["common"])

  const form = useForm({
    initialValues: getInitialValues({
      ...defaultValues,
    }),
    validate: {
      site: (value) => value ? undefined : t("common.validation.required", "Required"),
      serviceType: (value) => value ? undefined : t("common.validation.required", "Required"),
      statusFacet: (value) => value ? undefined : t("common.validation.required", "Required"),
      status: (value) => value ? undefined : t("common.validation.required", "Required"),
      asOfDate: (value) => value ? undefined : t("common.validation.required", "Required"),
      serviceMode: (value) => value ? undefined : t("common.validation.required", "Required"),
      confidencePct: (value) => value ? undefined : t("common.validation.required", "Required"),
    },
  })

  return form
}
